var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanFillType3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_3",
    "data-name": "Camada 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.08 303.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f41616;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.68,253.05c32.22-67.48,1.25-106.24-39.44-134.5C105.57,79.87,125.43,0,125.43,0c-60.26,53.87-29.75,112.74-9.32,153.34,11.8,23.45,3.72,45.76-25.72,48.92-58.62,6.29-48.66-92.79-48.66-92.79C-25.55,188.74,7.57,247.6,12.37,253.18c0,0,29,50.06,94.66,50.16,70.91.11,93.66-50.29,93.66-50.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFillType3);
export default __webpack_public_path__ + "static/media/plan-fill-type-3.27b872088e2dfac1359f9dd86f616544.svg";
export { ForwardRef as ReactComponent };